export const HOT_LIST_TYPE: HOTLISTTypeEMU = {
  CASINO: 2,
  LIVE: 3,
};

export interface HOTLISTTypeEMU {
  CASINO: number;
  LIVE: number;
  [key: string]: number; // 添加索引签名
}
